<template>
  <div
    class="soduku-container"
    :class="{ 'soduku--border': isBorder, 'soduku--highLight': highLight }"
    :style="[{ 'background-color': bgColor }, containerStyle_]"
  >
    <div
      v-for="(item, index) in list_"
      :key="index"
      class="soduku-row"
      :style="rowBoxStyle_"
    >
      <div
        v-for="(it, i) in item"
        :key="i"
        class="soduku-cell"
        :class="{
          'soduku-cell--square': square,
          'soduku-cell-box--fake': it._fake
        }"
        :style="cellStyle_"
        @click="handleClick(it, index * cols + i)"
      >
        <div class="soduku-cell-view">
          <div class="soduku-cell-padding"></div>
          <div class="soduku-cell-box" :style="cellBoxStyle_(it)">
            <el-badge
              v-bind="it.badge"
              class="soduku-cell-badge"
              :hidden="badgeHiden_(it, 1)"
            >
              <el-image
                v-if="it.image"
                class="soduku-cell-image"
                :src="it.image"
                v-bind="it.imageConfig"
                :style="imageStyle_"
              />
              <cnd-icon
                v-else-if="it.icon"
                :name="it.icon"
                :color="iconColor || color"
                :style="iconStyle_"
                class-name="soduku-cell-icon"
              />
            </el-badge>
            <el-badge
              v-bind="it.badge"
              class="soduku-cell-badge"
              :hidden="badgeHiden_(it, 2)"
            >
              <div
                class="soduku-cell-label"
                :style="cellLabelStyle_"
                v-html="it.label"
              ></div>
            </el-badge>
            <div class="soduku-cell-description" v-html="it.description"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../../../../lib/styles/components/Soduku.scss'
export default {
  name: 'Soduku',
  props: {
    // 宫格列数
    cols: {
      type: [String, Number],
      default: 3
    },
    // 是否显示边框
    isBorder: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default() {
        return []
      }
    },
    // 文字大小，隐藏参数不在文档中显示，通过css变量设置
    size: {
      type: [String, Number],
      default: ''
    },
    // icon大小，隐藏参数不在文档中显示，通过css变量设置
    iconSize: {
      type: [String, Number],
      default: ''
    },
    // 图片大小，隐藏参数不在文档中显示，通过css变量设置
    imageSize: {
      type: [String, Number],
      default: ''
    },
    // 文字颜色，隐藏参数不在文档中显示，通过css变量设置
    color: {
      type: String,
      default: ''
    },
    // icon颜色，隐藏参数不在文档中显示，通过css变量设置
    iconColor: {
      type: String,
      default: ''
    },
    // 背景颜色，隐藏参数不在文档中显示，通过css变量设置
    bgColor: {
      type: String,
      default: ''
    },
    // 边框元素，隐藏参数不在文档中显示，通过css变量设置
    borderColor: {
      type: String,
      default: ''
    },
    // 宫格间距
    gutter: {
      type: Number,
      default: 0
    },
    // 点击背景是否高亮
    highLight: {
      type: Boolean,
      default: true
    },
    // 是否正方形显示
    square: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    // 转换为二维度数组
    list_() {
      const result = []
      const fakeBox = { _fake: true }
      const list = [...this.list]
      if (list.length % this.cols !== 0 && !this.gutter_) {
        list.push(fakeBox)
      }
      list.forEach((v, i) => {
        const index = Math.floor(i / this.cols)
        let item = result[index]
        if (!item) {
          item = []
          result.push(item)
        }
        item.push(v)
      })
      return result
    },
    // 宫格间距值转换
    gutter_() {
      return Number.parseFloat(this.gutter)
    },
    // 整体样式
    containerStyle_() {
      const padding = this.gutter_ / 2
      if (this.isBorder) {
        if (this.gutter_) {
          return {
            border: 'none',
            padding: `${padding}px`
          }
        } else {
          return {
            borderColor: this.borderColor
          }
        }
      } else {
        return {
          border: 'none'
        }
      }
    },
    // 行样式
    rowBoxStyle_() {
      if (this.isBorder && !this.gutter_) {
        return {
          borderColor: this.borderColor
        }
      } else {
        return {
          border: 'none'
        }
      }
    },
    // 单个宫格整个的样式
    cellBoxStyle_() {
      return (it) => {
        const style = { backgroundColor: it.bgColor }
        if (this.isBorder && this.gutter_) {
          Object.assign(style, {
            border: '1px solid',
            borderColor: this.borderColor
          })
        } else {
          Object.assign(style, {
            borderColor: this.borderColor
          })
        }
        Object.assign(style, it.style)
        return style
      }
    },
    // 单个宫格内部的样式
    cellStyle_() {
      const width = `${100 / this.cols}%`
      if (this.gutter_) {
        const padding = this.gutter_ / 2
        return {
          width,
          padding: `${padding}px`
        }
      }
      return {
        width,
        borderColor: this.borderColor
      }
    },
    // label的样式
    cellLabelStyle_() {
      return {
        fontSize: this.getSize(this.size),
        color: this.color
      }
    },
    iconStyle_() {
      if (this.iconSize || this.iconSize === 0) {
        return {
          width: this.getSize(this.iconSize),
          height: this.getSize(this.iconSize)
        }
      } else {
        // 覆盖cnd-icon组件的style样式，让css样式生效
        return {
          width: '',
          height: ''
        }
      }
    },
    // 图片的样式
    imageStyle_() {
      const size = this.getSize(this.imageSize)
      return {
        width: size,
        height: size
      }
    },
    // 用于判断角标隐藏和显示
    badgeHiden_() {
      return (item, type) => {
        const hidden = item.badge?.hidden
        if (type === 1) {
          return hidden === true || (!item.image && !item.icon)
        } else if (type === 2) {
          return hidden === true || item.image || item.icon
        }
        return false
      }
    }
  },
  methods: {
    handleClick(item, index) {
      this.$emit('click', item, index)
    },
    getSize(x) {
      return isNaN(x) ? x : `${x}px`
    }
  }
}
</script>
